module.exports = __webpack_public_path__ + "static/media/forever_tricolour_3.97c462d0.jpg";